export const MainDefaultValue = {
  smc: false,
  site: '',
  contact: '',
  address: '',
  addressOptional: '',
  country: 'US',
  zip: '',
  state: '',
  city: '',
  code: '+1',
  phone: '',
  cell: '',
  safetyCompanyName: '',
  siteType: '',
  note: '',
  smcId: '',
};
